import type { ProductThumbSize } from '../components/product-thumb';
import type { ListDensity } from '../store/list-view.store';

/**
 * The one table of sizes every catalog-enrichment list derives its layout from, so compact /
 * normal / spacious mean the same thing on every screen.
 */
export const DENSITY = {
  compact: { rowClass: 'py-1.5', thumb: 'xs', twoLine: false, cardMin: '200px' },
  normal: { rowClass: 'py-2.5', thumb: 'sm', twoLine: true, cardMin: '260px' },
  spacious: { rowClass: 'py-4', thumb: 'md', twoLine: true, cardMin: '320px' },
} as const satisfies Record<
  ListDensity,
  { rowClass: string; thumb: ProductThumbSize; twoLine: boolean; cardMin: string }
>;
